/**
 * RJSF passes the whole wizard's accumulated form data down through
 * `formContext.formData`, with `registry.formContext.formData` as a
 * fallback depending on how the field is mounted. This lets a dependent
 * field (e.g. DomainPicker) read a sibling field's current value
 * (e.g. the selected Tenant) without the parent needing to pass it down
 * explicitly.
 */
export function readSiblingFormData(
  props: unknown,
  fieldName: string,
): unknown {
  const extended = props as {
    formContext?: { formData?: Record<string, unknown> };
    registry?: { formContext?: { formData?: Record<string, unknown> } };
  };

  const formData =
    extended.formContext?.formData ??
    extended.registry?.formContext?.formData;

  return formData?.[fieldName];
}
